import React from 'react';

import ActivityTypeFilter from './activity_type';
import BrokerFilter from './broker';
import DateFilter from './date_filter';
import FilterTags from './filter_tags';
import ParentTypeFilter from './parent_type';
import QueryFilter from './query';

import type { Features, FilterOptions } from 'bundles/apex/activities/types';
import type { Filters, ActivityFilters } from './types';

export interface Props {
  features?: Features;
  filterOptions?: FilterOptions;
  filters: Filters;
  show?: boolean | ActivityFilters;
  onChange: (changes: Partial<Filters>, debounce?: boolean) => void;
}

export default function ActvitiesFilters({ features, filterOptions, filters, show, onChange }: Props) {
  if (!show) {
    return null;
  }

  const filterProps = { ...filters, ...features, onChange };
  const showFilters = typeof show === 'boolean' ? {
    query: true,
    parentType: true,
    activityType: true,
    date: true
  } : show;

  return (
    <div className="d-flex flex-column flex-column mb-4">
      <div className="d-flex gap-2 w-100">
        {showFilters.query && <QueryFilter {...filterProps} onChange={changes => onChange(changes, true)} />}
        {showFilters.parentType && <ParentTypeFilter {...filterProps} />}
        {showFilters.activityType && <ActivityTypeFilter {...filterProps} />}
        {filterOptions && filterOptions.brokers.length > 1 &&
          <BrokerFilter {...filterProps} brokerOptions={filterOptions.brokers} />}
        {showFilters.date && <DateFilter {...filterProps} />}
      </div>
      <FilterTags filterOptions={filterOptions} filters={filters} onChange={onChange} />
    </div>
  );
}
